import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

const SeoSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$seoSection' });

  return (
    <section id="hp-seo" className="hp-section seo-section seo">
      <div className="seo-copy">
        <div className="seo-img-wrap">
          <picture>
            <source
              srcSet="/images/homepage/seoSection/LEM-seo-mob.jpg"
              media="(max-width: 768px)"
            />
            <img
              src="/images/homepage/seoSection/LEM-seo.jpg"
              alt="SEO"
              width="1920"
              height="700"
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
        </div>
        <div className="seo-copy-wrap">
          <h2>{t('title')}</h2>
          <p dangerouslySetInnerHTML={{ __html: t('copy') }} />
        </div>
      </div>
    </section>
  );
};

export default SeoSection;
